export const eye = [
  112, 113, 114, 115, 116, 122, 123, 124, 125, 126, 132, 133, 134, 135, 136,
  142, 143, 144, 145, 146, 152, 153, 154, 155, 156, 162, 163, 164, 165, 166,
  172, 173, 174, 175, 176,
];

export const eyeGameProps = [
  "eyeGameProps1",
  "eyeGameProps2",
  "eyeGameProps3",
  "eyeGameProps4",
  "eyeGameProps5",
  "eyeGameProps6",
  "eyeGameProps7",
];

export const eyeGamePropsDetail = [
  "eyeGameProps1Detail",
  "eyeGameProps2Detail",
  "eyeGameProps3Detail",
  "eyeGameProps4Detail",
  "eyeGameProps5Detail",
  "eyeGameProps6Detail",
  "eyeGameProps7Detail",
];

export const tail = [
  212, 213, 214, 215, 216, 222, 223, 224, 225, 226, 232, 233, 234, 235, 236,
  242, 243, 244, 245, 246, 252, 253, 254, 255, 256, 262, 263, 264, 265, 266,
  272, 273, 274, 275, 276,
];

export const tailGameProps = [
  "tailGameProps1",
  "tailGameProps2",
  "tailGameProps3",
  "tailGameProps4",
  "tailGameProps5",
  "tailGameProps6",
  "tailGameProps7",
];

export const tailGamePropsDetail = [
  "tailGameProps1Detail",
  "tailGameProps2Detail",
  "tailGameProps3Detail",
  "tailGameProps4Detail",
  "tailGameProps5Detail",
  "tailGameProps6Detail",
  "tailGameProps7Detail",
];

export const ornament = [
  312, 313, 314, 315, 316, 322, 323, 324, 325, 326, 332, 333, 334, 335, 336,
  342, 343, 344, 345, 346, 352, 353, 354, 355, 356, 362, 363, 364, 365, 366,
];

export const ornamentGameProps = [
  "ornamentGameProps1",
  "ornamentGameProps2",
  "ornamentGameProps3",
  "ornamentGameProps4",
  "ornamentGameProps5",
  "ornamentGameProps6",
];

export const ornamentGamePropsDetail = [
  "ornamentGameProps1Detail",
  "ornamentGameProps2Detail",
  "ornamentGameProps3Detail",
  "ornamentGameProps4Detail",
  "ornamentGameProps5Detail",
  "ornamentGameProps6Detail",
];

export const ear = [
  412, 413, 414, 415, 416, 422, 423, 424, 425, 426, 432, 433, 434, 435, 436,
  442, 443, 444, 445, 446, 452, 453, 454, 455, 456, 462, 463, 464, 465, 466,
];

export const earGameProps = [
  "earGameProps1",
  "earGameProps2",
  "earGameProps3",
  "earGameProps4",
  "earGameProps5",
  "earGameProps6",
];

export const earGamePropsDetail = [
  "earGameProps1Detail",
  "earGameProps2Detail",
  "earGameProps3Detail",
  "earGameProps4Detail",
  "earGameProps5Detail",
  "earGameProps6Detail",
];

export const foot = [
  512, 513, 514, 515, 516, 522, 523, 524, 525, 526, 532, 533, 534, 535, 536,
  542, 543, 544, 545, 546,
];

export const footGameProps = [
  "footGameProps1",
  "footGameProps2",
  "footGameProps3",
  "footGameProps4",
];

export const footGamePropsDetail = [
  "footGameProps1Detail",
  "footGameProps2Detail",
  "footGameProps3Detail",
  "footGameProps4Detail",
];

export const brindle = [
  612, 613, 614, 615, 616, 622, 623, 624, 625, 626, 632, 633, 634, 635, 636,
  642, 643, 644, 645, 646,
];

export const brindleGameProps = [
  "brindleGameProps1",
  "brindleGameProps2",
  "brindleGameProps3",
  "brindleGameProps4",
];

export const brindleGamePropsDetail = [
  "brindleGameProps1Detail",
  "brindleGameProps2Detail",
  "brindleGameProps3Detail",
  "brindleGameProps4Detail",
];

export const gameProps = [
  eyeGameProps,
  tailGameProps,
  ornamentGameProps,
  earGameProps,
  footGameProps,
  brindleGameProps,
];

export const gamePropsDetail = [
  eyeGamePropsDetail,
  tailGamePropsDetail,
  ornamentGamePropsDetail,
  earGamePropsDetail,
  footGamePropsDetail,
  brindleGamePropsDetail,
];

export const metadatas = [
  {
    attack: 50,
    defense: 50,
    health: 50,
    luck: 35,
    momentum: 35,
  },
  {
    attack: 70,
    defense: 70,
    health: 70,
    luck: 49,
    momentum: 49,
  },
  {
    attack: 105,
    defense: 105,
    health: 105,
    luck: 73,
    momentum: 73,
  },
  {
    attack: 155,
    defense: 155,
    health: 155,
    luck: 108,
    momentum: 108,
  },
  {
    attack: 290,
    defense: 290,
    health: 290,
    luck: 203,
    momentum: 203,
  },
];
